import moment from "moment"

export const FEATURE_DIRECTOR_ID = "id realisateur"
export const FEATURE_ACTOR_ID = "id acteur"

export const FEATURE_CLASSIFICATION = "classification csa"
export const FEATURE_YEAR = "année"
export const FEATURE_ORIGIN = "pays"
//TODO Remove duplicate
export const FEATURE_COUNTRY = "pays"
export const FEATURE_DURATION = "durée"
export const FEATURE_EDITO_CITATION = "édito citation"
export const FEATURE_EDITO_CITATION_AUTHOR = "édito citation auteur"
export const FEATURE_GUEST_CITATION = "invité citation"
export const FEATURE_GUEST_CITATION_AUTHOR = "invité auteur"
export const FEATURE_ORIGINAL_TITLE = "nom original"
export const FEATURE_DATE_FROM = "date début"
export const FEATURE_DATE_TO = "date fin"
export const FEATURE_LIST_OF_MONTH = "liste du mois"
export const FEATURE_AVAILABLE = "disponible"
export const FEATURE_STATUS = "état"
export const FEATURE_VIDEO_TYPE = "type video"
export const FEATURE_BONUS_TYPE = "bonus type"
export const FEATURE_SELECTION_FOCUS = "selection focus"

export const FEATURE_STATUS_COPY = "état copie"
//TODO Remove duplicate
export const FEATURE_COPY_STATE = "état copie"
export const FEATURE_FORMAT_VIDEO = "format vidéo"
//TODO Remove duplicate
export const FEATURE_VIDEO_STATE = "format vidéo"
export const FEATURE_FORMAT_AUDIO = "format audio"
//TODO Remove duplicate
export const FEATURE_SOUND_STATE = "format audio"
export const FEATURE_SHOOTING_SUPPORT = "support tournage"
export const FEATURE_PRODUCTION_YEAR = "année de production"
export const FEATURE_ORIGINAL_SOUND = "son origine"
export const FEATURE_RELEASE_DATE_FRANCE = "date sortie france"
export const FEATURE_TYPE_FILM = "type de film"
export const FEATURE_COLORS = "couleurs"
export const FEATURE_LANG = "langue"
export const FEATURE_SCENARIO = "scenario"
export const FEATURE_PHOTO = "Photographie"
export const FEATURE_MONTAGE = "montage"
export const FEATURE_BO = "Musique originale"
export const FEATURE_PRODUCTOR = "Producteur"
export const FEATURE_PRODUCTION_FIRM = "Société de production"
export const FEATURE_RIGHTS = "Ayant-droit"
export const FEATURE_CSA = "csa"
export const FEATURE_SUBTITLES = "Sous-titre"
export const FEATURE_EMBEDDED_SUBTITLES = "sous titres incrustes"
export const FEATURE_RESTORED_VERSION = "version restauree"
export const FEATURE_NOTE_FILM = "note fiche film"

export const FEATURE_VERSION_AUDIO = "materiel versions originales"
export const FEATURE_VERSION_DUBBING = "materiel versions doublees"

export const FEATURE_BUNDLE_SUBTITLES = "sous titres bundle"
export const FEATURE_BUNDLE_SUBTITLES_SME = "sous titres SME bundle"
export const FEATURE_BUNDLE_NOTE = "note fiche film"

export const FEATURE_CLASSIFICATION_ALL = "Tous publics"
export const FEATURE_CLASSIFICATION_ALL_WITH_ADV = "Tous publics avec avertissement"
export const FEATURE_CLASSIFICATION_18 = "-18"
export const FEATURE_CLASSIFICATION_16 = "-16"
export const FEATURE_CLASSIFICATION_12 = "-12"

export const FEATURE_VALUE_STATUS_ACQUISITION = "Nouvelle acquisition|New acquisition|Neuerwerb"
export const FEATURE_VALUE_STATUS_BLOCKED = "Droits bloqués actuellement|VOD unavailable|Derzeit gesperrte Rechte"
export const FEATURE_VALUE_STATUS_AVAILABLE_SOON = "Bientôt en ligne|Coming soon online|Demnächst online"
export const FEATURE_VALUE_STATUS_RESTORATION = "En cours de restauration|In restoration|Unter Restaurierung"
export const FEATURE_VALUE_STATUS_CATALOG = "Catalogue|In catalog|Katalog"
export const FEATURE_VALUE_STATUS_NEGO = "Négociation en cours|Not found, help us|Verhandlung läuft"
export const FEATURE_VALUE_UNAVAILABLE = "Pas encore disponible|Acquisition in progress|Noch nicht verfügbar"
export const FEATURE_VALUE_COPY = "Copie indisponible|Numerisation|Nicht verfügbare Kopie"

export const FEATURE_CINECLUB_DATE = "cineclub date"
export const FEATURE_CINECLUB_DISPO_FR = "dispo France"
export const FEATURE_CINECLUB_DISPO_BE = "dispo Belgique"
export const FEATURE_CINECLUB_DISPO_LU = "dispo Luxembourg"
export const FEATURE_CINECLUB_DISPO_DE = "dispo Allemagne"
export const FEATURE_CINECLUB_DISPO_AT = "dispo Autriche"
export const FEATURE_AGGREGATOR_TVOD_FR_DATE_FROM = "Date de début agrégateur TVOD FR"
export const FEATURE_AGGREGATOR_TVOD_FR_DATE_TO = "Date de fin agrégateur TVOD FR"
export const FEATURE_AGGREGATOR_SVOD_FR_DATE_FROM = "Date de début agrégateur SVOD FR"
export const FEATURE_AGGREGATOR_SVOD_FR_DATE_TO = "Date de fin agrégateur SVOD FR"
export const FEATURE_AGGREGATOR_TVOD_BE_LU_DATE_FROM = "Date de début agrégateur TVOD BE/LU"
export const FEATURE_AGGREGATOR_TVOD_BE_LU_DATE_TO = "Date de fin agrégateur TVOD BE/LU"
export const FEATURE_AGGREGATOR_SVOD_BE_LU_DATE_FROM = "Date de début agrégateur SVOD BE/LU"
export const FEATURE_AGGREGATOR_SVOD_BE_LU_DATE_TO = "Date de fin agrégateur SVOD BE/LU"
export const FEATURE_AGGREGATOR_TVOD_DE_AT_DATE_FROM = "Date de début agrégateur TVOD DE/AT"
export const FEATURE_AGGREGATOR_TVOD_DE_AT_DATE_TO = "Date de fin agrégateur TVOD DE/AT"
export const FEATURE_AGGREGATOR_SVOD_DE_AT_DATE_FROM = "Date de début agrégateur SVOD DE/AT"
export const FEATURE_AGGREGATOR_SVOD_DE_AT_DATE_TO = "Date de fin agrégateur SVOD DE/AT"

export const FEATURE_QUOTE = "quote"

export const FEATURE_LIST_COMMENT = "commentaires liste"
export const FEATURE_LIST_LETTER_ID = "list letter id"

export const FEATURE_PREHOME_POSITION = "prehome position"
export const FEATURE_PREHOME_BUTTON_1_LABEL = "prehome button 1 label"
export const FEATURE_PREHOME_BUTTON_1_LINK = "prehome button 1 link"
export const FEATURE_PREHOME_BUTTON_1_TITLE = "prehome button 1 title"
export const FEATURE_PREHOME_BUTTON_2_LABEL = "prehome button 2 label"
export const FEATURE_PREHOME_BUTTON_2_LINK = "prehome button 2 link"
export const FEATURE_PREHOME_BUTTON_2_TITLE = "prehome button 2 title"
export const FEATURE_PREHOME_BUTTON_3_LABEL = "prehome button 3 label";
export const FEATURE_PREHOME_BUTTON_3_LINK = "prehome button 3 link";
export const FEATURE_PREHOME_BUTTON_3_TITLE = "prehome button 3 title";
export const FEATURE_PREHOME_DURATION = "prehome duration"
export const FEATURE_PREHOME_MAX_DISPLAY = "prehome max display"

export const FEATURE_INVERTED_NAME = "nom inversé"
export const FEATURE_INVERTED_NAME_TRUE = "Oui"
export const FEATURE_INVERTED_NAME_FALSE = "Non"

export const FEATURE_LIST_AVAILABLE_TRUE = "Oui"
export const FEATURE_LIST_AVAILABLE_FALSE = "Non"

export const FEATURE_FESTIVAL_SUBSCRIPTIONS = "abonnements festival"
export const FEATURE_FESTIVAL_PRESENTATION_FOR = "presentation festival|presentation for festivals"
export const FEATURE_FESTIVAL_FILM_AVAILABLE_DATE = "date dispo festival"

export const FEATURE_PARTNERS = "partenaires"

export const FEATURE_CODE_ALLOCINE = "code allocine"

const languages = ["fr", "en"]
export const FEATURE_GENRE = "genre"
export const FEATURE_GENRE_MAN = "Homme"
export const FEATURE_GENRE_WOMAN = "Femme"

export const FEATURE_FREEBOX_EVENT_POSITION = "freebox event position"
export const FEATURE_FREEBOX_EVENT_LINK = "freebox event link"

export const FEATURE_HIDE_IN_PRODUCTION = "cacher en production"
export const FEATURE_HIDE_IN_CATALOG = "cacher dans le catalogue"
export const FEATURE_HIDE_IN_PRODUCTION_ARTICLE = "STAGING"

export const FEATURE_BONUS_ARCHIVE_TITLE = "bonus archive titre emission"
export const FEATURE_BONUS_ARCHIVE_YEAR = "bonus archive annee"

export const SVOD_BLOCK_TYPE = "Bloc type"
export const SVOD_TYPE_HEADER = "en-tete"
export const SVOD_TYPE_SPOTLIGHT = "film a l honneur"
export const SVOD_TYPE_TEMATICS = "thematique"
export const SVOD_TYPE_SQUARE = "carre"
export const SVOD_TYPE_SLIDER = "slider"
export const SVOD_RAIL_BONUSES = "id rail bonus"
export const SVOD_RAIL_TVOD = "Rebond TVOD"
export const SVOD2_LINK_BUTTON = "bouton lien"
export const SVOD2_HAS_NOT_SUBSCRIBED = "uniquement pour non-abonne"
export const SVOD_END_DATE = "date fin"
export const TEXT_BUTTON = "bouton texte"
export const SVOD_EDITO_CITATION = "édito citation"
export const SVOD_EDITO_AUTOR = "édito citation auteur"
export const SVOD_IMAGE_TITLE = "Bloc titre-image"
export const SVOD_BLOCK_TEXT = "Bloc texte"
export const SVOD_BLOCK_TEXT_LONG = "Bloc texte long"

export function metadata(object, label, options) {
	let value
	if (!object || !object.metadata) {
		value = null
	} else {
		value = object.metadata.find(f => label.toLowerCase().split("|").includes(f.name.toLowerCase()))
		if (value) value = value.value
	}

	switch(label) {
		case FEATURE_DURATION:
			value = manageDuration(value)
			break
		case FEATURE_LIST_COMMENT:
			if (options) {
				if (object.id == 572) {
					value = JSON.stringify(shittyTruff)
				}
				if (value && options.id) {
					const comment = JSON.parse(value).find(c => c.id == options.id)
					value = comment ? comment.comment : null
				}
			} else if (!value) {
				value = []
			}
			break
		case FEATURE_INVERTED_NAME:
			value = (value == FEATURE_INVERTED_NAME_TRUE)
			break
	}

	if (options) {
		if (options.oneOf) {
			value = (options.oneOf.find(o => o.split("|").includes(value)) !== undefined)
		}

		if (options.isEqual) {
			value = options.isEqual.split("|").includes(value)
		}

		if (!value && options.defaultValue) {
			if (options.language) {
				value = options.defaultValue.split('|')[languages.indexOf(options.language)]
			} else {
				value = options.defaultValue
			}
		}
	}

	return value
}

export const manageDuration = (duration) => {
	if (!duration || duration == 0) return "no-duration"
	else return moment().startOf("day").add(duration, "minutes").format("H[h]mm")
}

const shittyTruff = [{
		id: 195,
		comment: "Les chefs-d'œuvre consacrés  à l'enfance en littérature ou dans le cinéma se comptent sur les doigts de la main. Ils nous bouleversent doublement  car à l'émotion esthétique vient s'ajouter une émotion biographique, personnelle et intime."
	},
	{
		id: 251,
		comment: "L'Atalante aborde en réalité un grand thème, peu souvent traité au cinéma, les débuts dans la vie d'un jeune couple, les difficultés de s'adapter l'un à l'autre, avec d'abord l'euphorie de l'accouplement (ce que Maupassant appelle \"le brutal appétit physique bien vite éteint\"), puis les premiers heurts, la révolte, la fugue, la réconciliation et finalement l'acceptation l'un par l'autre",
	},
	{
		id: 223,
		comment: "Tout Orson Welles est dans la première bobine de Citizen Kane, tout Bunuel dans Le Chien Andalou, tout Godard dans Une Jeune Coquette, donc tout Jean Vigo est dans A propos de Nice."
	},
	{
		id: 292,
		comment: "Il n'est pas un plan dans Napoléon, une scène qui ne nous donne pas à penser qu'elle est le clou du film, pas un plan qui ne soit chargé d'émotion, pas un acteur qui ne donne le meilleur de lui-même.",
	},
	{
		id: 1326,
		comment: "Jean Renoir aura été le premier à rendre évidente cette vérité : lorsque Michel Simon joue, nous pénétrons au cœur du cœur humain."
	},
	{
		id: 1240,
		comment: "Toni dans la carrière de Renoir est un film pivot, un départ vers une tout autre direction. Dix ans avant les cinéastes italiens, il inventait le néo-réalisme (...)"
	},
	{
		id: 1857,
		comment: "La Marseillaise est construit comme un western car c'est le seul film baladeur de Renoir."
	},
	{
		id: 390,
		comment: "La Bête humaine est probablement le meilleur film de Jean Gabin. \"Jacques Lantier m'intéresse autant qu'Œdipe Roi\" a dit Renoir de ce drame.",
	},
	{
		id: 142,
		comment: "La Règle du jeu c'est le crédo des cinéphiles, le film des films, le plus haï à sa sortie, le plus apprécié ensuite jusqu'à devenir un véritable succès commercial (...)"
	},
	{
		id: 1086,
		comment: "Le Carrosse d'Or est l'un des films-clés de Renoir puisqu'il rassemble les thèmes de plusieurs autres, principalement celui de la sincérité en amour et celui de la vocation artistique."
	},
	{
		id: 75,
		comment: "French Cancan a marqué une date dans l'histoire de la couleur au cinéma. (…) Chaque plan est une gravure populaire, une \"image d'Epinal\" en mouvement."
	},
	{
		id: 1831,
		comment: "S'il vous semble surprenant que ce film réaliste soit en même temps un conte de fées, écoutez la réponse de Jean Renoir : \"La réalité est toujours féérique. Pour arriver à rendre la réalité non féérique, il faut que certains auteurs se donnent beaucoup de mal, et la présentent sous un jour vraiment bizarre.\""
	},
	{
		id: 628,
		comment: "Si je pense à Carl Dreyer, ce qui me vient tout d'abord à l'esprit, ce sont des images blanches, les splendides gros plans silencieux de La Passion de Jeanne d'Arc (...)"
	},
	{
		id: 445,
		comment: "Chaque image d'Ordet est d'une perfection formelle qui atteint au sublime mais on sait que Dreyer est davantage qu'un \"plasticien\" (...)"
	},
	{
		id: 318,
		comment: "Dans le gruyère Lubitsch, chaque trou est génial."
	},
	{
		id: 67,
		comment: "Le Dictateur a vieilli et c'est heureux. Il a vieilli comme un éditorial politique, comme J'accuse de Zola, comme une conférence de presse; c'est un admirable documment, une pièce rare, un objet utile devenu obet d'art (...)"
	},
	{
		id: 146,
		comment: "\"L'œuvre d'art, explique quelque part Jean Genet, doit résoudre le drame et nous l'exploser.\" Charlie Chaplin résout le drame, grâce à son secret qui s'appelle la lucidité."
	},
	{
		id: 1853,
		comment: "Le film n'a pas pris une ride, grâce à son extraordinaire dépouillement, sa rigueur et aussi la sincérité de sa violence, surprenante aujourd'hui encore."
	},
	{
		id: 519,
		comment: "Fenêtre sur cour est le film de l'indiscrétion, de l'intimité violée et srprise dans son caractère le plus infâmant, le film du bonheur impossible, le film du linge sale qui se laverait dans la cour (...)"
	},
	{
		id: 348,
		comment: "On ne manquera pas de comparer Le Faux coupable au film de Robert Bresson, un condamné à mort s'est échappé et il serait stupide que ce fût au détriment d'Hitchcock dont le film a d'emblée la noblesse de ne point jouer la carte de la noblesse."
	},
	{
		id: 943,
		comment: "En vérité, on ne pardonne pas à Hitchcock de nous faire peur et de ne viser qu'à cela. Je crois pourtant que la peur est une émotion \"noble\" et qu'il peut être \"noble\" de faire peur."
	},
	{
		id: 1419,
		comment: "Il faut voir En quatrième vitesse car, si l'on connaît les conditions dans lesquelles se tournent les films d'aujourd'hui, on ne pourra qu'admirer l'extraordinaire liberté dont a bénéficié celui-ci, que l'on se surprend à maintes reprises à comparer au Sang d'un poète de Cocteau."
	},
	{
		id: 1873,
		comment: "Outre qu'il représente une très exacte peinture de Hollywood, Le Grand couteau est le film américain le plus raffiné et le plus intelligent que l'on nous ai offert depuis plusieurs mois."
	},
	{
		id: 1843,
		comment: "Une femme qui s'affiche est un chef-d'œuvre car, pour tenir 90 minutes le même rythme sans faiblir, installer en permanence le sourire entre les rires, diriger des gens comme on le fait ici, il faut être un maître."
	},
	{
		id: 1848,
		comment: "J'irai revoir ce film car je sors toujours d'un film de Samuel Fuller admiratif et jaloux, puisque j'aime recevoir des leçons de cinéma."
	},
	{
		id: 323,
		comment: "Charles Laughton ne craint pas de brûler quelques feux rouges et de renverser quelques policemen dans ce film unique qui fait aimer le cinéma de recherches quand il cherche vraiment et le cinéma de trouvailles quand il trouve."
	},
	{
		id: 1871,
		comment: "Prisonnier de la peur est un film amer et désabusé qui ne donne guère envie de vivre en Amérique. Mais, s'il se trouvait en France des cinéastes aussi lucides et talentueux que Mulligan, comme lui capables de dépasser l'anecdote, nous aurions sur l'écran une image de notre pays un peu moins simplifiée."
	},
	{
		id: 1860,
		comment: "Jean Seberg, avec ses petits cheveux blonds cendrés sur son crâne de pharaon, ses yeux bleus grands ouverts et ses éclairs de malice garçonnière, porte sur ses petites épaules tout ce film qui n'est d'ailleurs qu'un poème d'amour que lui dédie Otto Preminger."
	},
	{
		id: 1849,
		comment: "Love me or leave me (…) nous offre, de la vie conjugale, d'une chanteuse et de son impresario, une peinture extrêmement vraisemblable et intelligente, d'une finesse et d'une sincérité rare."
	},
	{
		id: 1475,
		comment: "Ne riez pas trop fort en voyant La Traversée de Paris, d'abord pour permettre à vos voisins de suivre le dialogue et, surtout, parce que Martin et Grandgil, c'est comme qui dirait vous et moi ..."
	},
	{
		id: 309,
		comment: "Casque d'or, parfois drôle et parfois tragique, prouve enfin que, par l'utilisation raffinée du changement de ton, on peut dépasser la parodie, regarder un passé pittoresque et sanglant puis le ressusciter avec tendresse et violence."
	},
	{
		id: 1068,
		comment: "La beauté des personnages du Grisbi, plus encore que de ceux de Casque d'or, vient de leur mutisme, de l'économie de leurs gestes; ils ne parlent ou n'agissent que pour dire et faire l'essentiel."
	},
	{
		id: 1874,
		comment: "Arsène Lupin est une bouteille d'eau minérale : cela rafraîchit et cela pétille, mais on peut préférer le champagne."
	},
	{
		id: 508,
		comment: "Le Trou est un film superbe, superbement conçu, écrit, réalisé, monté et bruité. C'est, par bonheur, le meilleur film de Jacques Becker, par bonheur car les critiques, qui seront en l'occurrence des notaires, pourront ouvrir un bon testament."
	},
	{
		id: 120,
		comment: "Pour moi, Un condamné à mort s'est échappé est non seulement le plus beau film de Robert Bresson mais aussi le film français le plus décisif de ces dix dernières années."
	},
	{
		id: 1576,
		comment: "Ce sentiment que nous éprouvons d'assister, non au spectacle d'un film prééxistant, mais à l'acte créateur \"en train de se faire\", est accru par le fait que Clouzot lui-même, en dirigeant les prises de vus, ignorait ce qu'allait tracer Picasso."
	},
	{
		id: 98,
		comment: "Le Roman d'un tricheur, considéré à juste titre comme le chef d'œuvre de Sacha Guitry, film picaresque aux deux tiers commenté, riche en trouvailles inédites et jamais rééditées."
	},
	{
		id: 1329,
		comment: "Lola Montès est le film des records : c'est le meilleur film français de l'année, le meilleur cinémascope à ce jour et Max Ophüls s'y affirme comme le meilleur technicien français actuel et le meilleur directeur d'acteurs."
	},
	{
		id: 382,
		comment: "Tati, comme Bresson, invente le cinéma en tournant; il refuse la structure de tous les autres."
	},
	{
		id: 1262,
		comment: "Pour moi, la leçon que nous donne Bergman tient en trois points : libération du dialogue, nettoyage radical de l'image, primauté absolue accordée au visage humain."
	},
	{
		id: 1505,
		comment: "Au contraire du Septième Sceau qui, inspiré par les vitraux moyen-âgeux, comportait beaucoup d'effets plastiques, Au Seuil de la vie est réalisé avec une grande simplicité, la mise en scène se plaçant entièrement au service des trois héroïnes à la manière dont Ingmar Bergman s'est effacé devant le scénario de Ulla Isaksson."
	},
	{
		id: 1841,
		comment: "Il y a dans ce \"grand petit film\" de quatre minutes toute la fantaisie de Giraudoux, la maîtrise d'Hitchcock et l'imagination de Cocteau."
	},
	{
		id: 565,
		comment: "Les films sur la médecine horripilent les médecins, les films sur l'aviation exaspèrent les aviateurs, mais Federico Fellini a réussi à combler les gens de cinéma avec Huit et demi."
	},
	{
		id: 544,
		comment: "Citizen Kane est en même temps un premier film par son aspect fourre-tout expérimental  et un film testamentaire par sa peinture globale du monde."
	},
	{
		id: 1855,
		comment: "Dans ce beau film, on retrouve, derrière chaque image, le souffle d'Orson Welles, son grain de folie et son grain de génie, sa puissance, son éclatante santé et sa corpulente poésie."
	},
	{
		id: 951,
		comment: "La Soif du mal nous réveille et vient nous rappeler que parmi les pionniers du cinéma il y eut Méliès, il y eut Feuillade. C'est un film magique qui nous fait penser aux contes de fées : La Belle et la Bête, Le Petit Poucet et aux fables de La Fontaine."
	},
	{
		id: 201,
		comment: "Lorsque la lumière se rallume, on n'ose pas applaudir, on reste sans voix devant une telle œuvre, confondu par l'importance et la nécessité de ces mille mètres de pellicule."
	},
	{
		id: 1838,
		comment: "Et Dieu créa la femme, film intime, film carnet de notes, révèle donc un nouveau metteur en scène."
	},
	{
		id: 1832,
		comment: "Voilà donc un film insolite et courageux qui relèvera le niveau de la production nationale en 1958 !"
	},
	{
		id: 1833,
		comment: "L'amour est le sujet des sujets, particulièrement au cinéma où l'aspect charnel est indissociable des sentiments. Louis Malle a réalisé le film que tout le monde porte en son cœur et rêve de concrétiser : l'histoire minutieuse d'un coup de foudre, le brûlant \"contact de deux épidermes\" qui n'apparaîtra que beaucoup plus tard comme \"l'échange de deux fantaisies\"."
	},
	{
		id: 1834,
		comment: "Jacques Rivette était le plus cinéphile d'entre nous, son film prouve aussi qu'il est le plus cinéaste. Compte tenu des conditions de tournage, Paris nous appartient est, de tius les films qui sont nés de l'équipe des \"Cahiers du cinéma\" le plus \"mis en scène\"."
	},
	{
		id: 1722,
		comment: "La joie physique et la douleur physique que procurent certains moments de A bout de souffle et Vivre sa vie, je ne chercherai jamais à les communiquer par l'écriture à ceux qui ne les ressentent pas."
	},
	{
		id: 481,
		comment: "Le premier film de Jacques Rozier, Adieu Philippine, est la plus évidente réussite de ce nouveau cinéma dont la spontanéité est d'autant plus forte quand elle est l'aboutissement d'un très long et minutieux travail."
	},
	{
		id: 1005,
		comment: "Tous les comiques connaissent le rire par répétition, il existe aussi un pathétique par répétition, c'est le plus intéressant. Grâce à cela, Louis Malle a réussi son meilleur film."
	},
	{
		id: 1340,
		comment: "Avec Muriel, Resnais traite exactement le même sujet que Renoir dans La Règle du jeu et que Chabrol dans Les Bonnes femmes : nous faisons les guignols en attendant la mort."
	},
	{
		id: 1835,
		comment: "(…) Je suis bouillant d'impatience à l'idée que Jean Renoir, lorsqu'il va revenir en France, regardera Le Vieil Homme et l'enfant et sera heureux comme chaque fois qu'il voit naître un enfant de Toni."
	},
	{
		id: 1867,
		comment: "Grâce à sa justesse de ton, son ironie affectueuse et la précision de son tir, Les Amis vient s'ajouter à la liste des \"premiers\" films qui furent en même temps des révélations."
	},
	{
		id: 517,
		comment: "Vincent, François, Paul et les autres c'est la vie, Claude Sautet c'est la vitalité."
	},
	{
		id: 237,
		comment: "Les Doigts dans la tête nous donne l'impression d'avoir atteint le plus haut degré de justesse dans le jeu; heureusement il ne s'agit que d'une impression, car la recherche de la vérité en art est comme l'escalade d'une échelle sans fin."
	}
]
